import { Component, Input } from '@angular/core';
import { NgClass, UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-status-badge',
    templateUrl: './status-badge.component.html',
    styleUrls: ['./status-badge.component.scss'],
    imports: [NgClass, UpperCasePipe, TranslateModule]
})
export class StatusBadgeComponent {
  @Input() status: string = '';
}
